﻿$.fn.dxCtrlGridFormulaire = function custom_dxCtrlGridFormulaire(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridformulaire dx-ctrl");
        this.createInstance(new cdxCtrlGridFormulaire(this, option));
    }
    return this;
}

window.cdxCtrlGridFormulaire = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "gridformulaire"

    var _disableUpdateFunction = false
    var timeOutUpdate = null
    option.bddCtrl.mAddFunctionOnModifiedItemData(["formulaire", "formulaire_reponse"], container,
        function (action, itemData) {
            if (_disableUpdateFunction) {
                _disableUpdateFunction = false
                return
            }
            window.clearTimeout(timeOutUpdate)
            timeOutUpdate = window.setTimeout(function () {
                if (typeof itemData != 'undefined') {
                    dxGrid.mUpdateData(action, option.bddCtrl.table.mGetItemFromNom("formulaire").id_table, itemData.id_formulaire)
                } else {
                    dxGrid.mReloadData()
                }
            }, 100)
        })

    var dxGrid = null
    function mConstruit() {
        container.empty();
        container.css("height", "100%")

        var lstField = mGetLstField()
        var opt = {
            bddCtrl: option.bddCtrl,
            noDataText: "Aucun formulaire",
            typeData: "formulaire",
            context_grid: option.context_grid,
            itemsToolbar: mGetLstButtonToolBar(),
            onDisplayButtonLigne: mGetLstButtonLigne,
            onEndClickDataGrid: option.onEndClickDataGrid,
            lstTypeGrille: ["Lignes"],
            lstLstConditionBase: option.lstLstConditionBase,
            fields: lstField,
            allowFilter: false,
            allowCarto: false,
            allowLucene: true,
            allowCheck: option.allowCheck,
            onClickDataGrid: option.onClickDataGrid,
            allowToolbar: option.allowToolbar,
            allowDeleteInToolbar: false,
            showColumnHeaders: option.showColumnHeaders,
            lstIdTableIdExclu: option.lstIdTableIdExclu,
            lstIdTableIdInclu: option.lstIdTableIdInclu
        }

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid(opt).dxCtrlVirtualGrid("instance")
    }

    function mGetLstField() {

        var lst = []

        lst = lst.concat([{
            name: "dcr",
            dataField: "dcr",
            caption: "Date création",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dcr.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Création: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            filterLinkGrp: "dcr_tri"
        }, {
            name: "dcr_tri",
            dataField: "dcr_tri",
            allowGrid: false,
            visible: false
        }, {
            name: "dmo",
            dataField: "dmo",
            caption: "Date modification",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dmo.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Modification: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            filterLinkGrp: "dmo_tri"
        }, {
            name: "dmo_tri",
            dataField: "dmo_tri",
            allowGrid: true,
            visible: false
        }, {
            name: "date_last_reponse",
            dataField: "date_last_reponse",
            caption: "Date dernière réponse",
            icon: "fas fa-comment",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            groupIndex: 0,
            sortOrder: "desc",
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return (rowData.date_last_reponse ? rowData.date_last_reponse.toGrpDate().id : "(aucune)")
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-comment dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Dernière réponse: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            filterLinkGrp: "date_last_reponse_tri"
        }, {
            name: "date_last_reponse_tri",
            dataField: "date_last_reponse_tri",
            allowGrid: true,
            visible: false
        }])

        lst = lst.concat([{
            name: "id_utilisateur",
            dataField: "id_utilisateur",
            caption: "Utilisateur",
            icon: "fas fa-user",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            calculateGroupValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            groupCellTemplate: function (columnElement, options) {
                var txt = options.data.key
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-user dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + ((txt.length == 0) ? "(Aucun utilisateur)" : txt) + " (" + tot + ")")
            },
            calculateCellValue: function (rowData) {
                return rowData.id_utilisateur
            },
            calculateSortValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            filterProperty: {
                lookup: option.bddCtrl.getObjet("utilisateur").objetMetier.mGetLookUpForFilterBuilder(),
                filterOperations: ["parmi", "notparmi"]
            }
        }, {
            name: "titre",
            dataField: "titre",
            caption: "Titre",
            icon: "fafa fafa-formulaire",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fafa fafa-formulaire dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Formulaire: " +
                    ((typeof options.displayValue == 'undefined' || options.displayValue.length == 0) ? "(aucun nom)" : options.displayValue) +
                    " (" + tot + ")")
            }
        }, {
            name: "fini",
            dataField: "fini",
            caption: "Fini",
            icon: "fas fa-check",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "boolean",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clipboard-question dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" +
                    ((options.displayValue == '1') ? "Fini" : "En cours") +
                    " (" + tot + ")")
            }
        }])

        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []
        //if (typeof option.showBtNew == 'undefined' || option.showBtNew) {
        //    items.push({
        //        location: 'before',
        //        visible: true,
        //        template: function (itemData, itemIndex, itemElement) {
        //            $("<div/>").appendTo(itemElement).dxCtrlButton({
        //                icon: "fas fa-tornado",
        //                icon2: "fas fa-certificate",
        //                colorIcone2: theme.colorBtIcon2,
        //                opacityIcone2: "0.9",
        //                txtTooltip: "Nouveau pipeline",
        //                onClick: function (e) {
        //                    option.bddCtrl.getObjet("pipeline").objetMetier.mShowNewPipeline()
        //                }
        //            }).dxCtrlButton("instance")
        //        }
        //    })
        //}
        return items
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {
        var items = []
        items.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            options: {
                icon: "fas fa-trash-alt",
                elementAttr: { class: "dx-button-grille-ligne" },
                focusStateEnabled: false,
                text: "Corbeille",
                hint: "Mettre à la corbeille",
                onClick(e) {
                    e.event.stopPropagation();
                    dxGrid.mRemoveRow(dataGrid)
                    var obj = option.bddCtrl.getObjet(option.bddCtrl.table.mGetItem(dataGrid.id_table).nom, dataGrid.id)
                    _disableUpdateFunction = true
                    obj.mDelData(function () { })
                }
            },
        })
        toolbar.option("items", items)
    }

    this.mChangeLstIdTableIdExclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdExclu(lstId)
    }
    this.mChangeLstIdTableIdInclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdInclu(lstId)
    }

    this.element = function () { return container }

    mConstruit();
}